/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

function getWindow() {
    if (typeof window === 'undefined') {
        return null;
    }

    return window;
}

export default getWindow;
